module.exports = __webpack_public_path__ + "static/img/yewuzixun.6174c910.png";